import { render, staticRenderFns } from "./settingsConsultDialog.vue?vue&type=template&id=52e5459e"
import script from "./settingsConsultDialog.vue?vue&type=script&lang=js"
export * from "./settingsConsultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports